import React from 'react'

export default class SubHeaderText extends React.Component {
    render() {
        return <div className="uiSubHeaderText" style={this.props.style}>{this.props.children}</div>

    }
}
